import styles from './index.module.css';
import { Typography, Box } from "@material-ui/core";
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useTranslation } from 'react-i18next';
import WarningIcon from "@material-ui/icons/Warning";
import SpeedIcon from "@material-ui/icons/Speed";
import { useHistory } from 'react-router-dom';

export interface IMileageOverview {
  mileageLimitExited: number;
  approachingMileageLimits: number;
}

const MileageOverview = ({ data }: { data: IMileageOverview }) => {
  const history = useHistory();
  const userState = useSelector((state: IAppState) => state.authReducer.user)
  const consumerState = useSelector((state: IAppState) => state.consumerWebsiteReducer)
  const { locale, currency } = consumerState.consumerWebsite.organisation
  const { t } = useTranslation()

  return (
    <Box className={styles.enhancedCard}>
      <Box className={styles.cardContentEnhanced}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
            {t("root:mileageOverview")}
          </Typography>
          <Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #f97316, #ea580c)" }}>
            🛣️
          </Box>
        </Box>

        <Box
          display="grid"
          gridTemplateColumns="1fr 1fr"
          gridGap="16px"
          style={{ maxWidth: 400, margin: "15px 0" }}
        >
          {/* Mileage Limit Exited */}
          <Box
            style={{
              padding: "15px",
              borderRadius: "16px",
              background: "linear-gradient(135deg, #fca5a5, #ef4444)",
              color: "#fff",
              textAlign: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Box display="flex" justifyContent="center" mb={1}>
              <WarningIcon fontSize="large" />
            </Box>
            <Typography style={{ fontSize: "14px", marginBottom: "8px", opacity: 0.9 }}>
              {t("root:mileageLimitExited")}
            </Typography>
            <Typography
              style={{
                fontWeight: 700,
                fontSize: "32px",
                lineHeight: 1.2,
                cursor: "pointer"
              }}
              onClick={() => history.push("/account/vehicles", {
                showMileageLimitExceededVehicles: true
              })}
            >
              {data.mileageLimitExited}
            </Typography>
          </Box>

          {/* Approaching Mileage Limits */}
          <Box
            style={{
              padding: "15px",
              borderRadius: "16px",
              background: "linear-gradient(135deg, #93c5fd, #3b82f6)",
              color: "#fff",
              textAlign: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Box display="flex" justifyContent="center" mb={1}>
              <SpeedIcon fontSize="large" />
            </Box>
            <Typography style={{ fontSize: "14px", marginBottom: "8px", opacity: 0.9 }}>
              {t("root:approachingMileageLimits")}
            </Typography>
            <Typography
              style={{
                fontWeight: 700,
                fontSize: "32px",
                lineHeight: 1.2,
                cursor: "pointer"
              }}
              onClick={() => history.push("/account/vehicles", {
                showApproachingMileageLimitVehicles: true
              })}
            >
              {data.approachingMileageLimits}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default MileageOverview;